<script>
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import Add from './add.vue';
import Switch from './switch.vue';
import AddTrial from './add-trial.vue';
import Trial2paid from './trial2paid.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};
    if (this.$context.is.add2cart) return <Add on={this.$listeners} />;
    if (this.$context.is.add2trial) return <AddTrial {...context} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...context} />;
    if (this.$context.is.edit) return <Edit on={this.$listeners} />;
    if (this.$context.is.switch) return <Switch {...context} />
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{ props: { ...this.$props }}} on={this.$listeners} />;
    return null;
  },
};
</script>
